import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthenticationService } from '@app/services/authentication.service';
import { MessageService } from 'primeng/api';
import { Messages } from '@app/constants/constant';
import { NgxPermissionsService, NgxRolesService } from 'ngx-permissions';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  siteKey: string;
  username = '';
  password = '';
  invalidLogin = false;
  token = '';
  error = '';
  recaptcha = ''

  constructor(private router: Router, private fb: FormBuilder,
    private loginService: AuthenticationService,
    private _toastService: MessageService,
    private permissionsService: NgxPermissionsService,
    private ngxRolesService: NgxRolesService,
  ) {  
    this.siteKey="6Lc0ej8qAAAAAIwPvH3mruz6CDEavFavKtUUopeE" 
  }

  loginForm: FormGroup;
  user: any;

  ngOnInit() {
    localStorage.removeItem('clearFilter');
    localStorage.removeItem('searchDto');
    localStorage.setItem('currentUser', null);
    this.loginForm = this.fb.group({
      username: new FormControl('', Validators.required),
      password: new FormControl('', Validators.compose([Validators.required, Validators.minLength(6)])),
      recaptcha: new FormControl(['', Validators.required])
    });
  }
  onSubmit(value: string) {
    // this.submitted = true;
    // this.messageService.add({ severity: 'info', summary: 'Success', detail: 'Form Submitted' });
  }
  handleSuccess($event){
    console.log($event);
    this.token = $event;
  }
  checkLogin() {
    if(!this.token){
      alert("Please select captcha")
      return 
    }
    (this.loginService.login(this.username, this.password, this.token).subscribe(
      data => {
        this.user = JSON.parse(localStorage.getItem('currentUser'))['user'];
        let permissions = [];
        if (this.user && this.user.role) {
          permissions.push(this.user.role.name);
          this.permissionsService.loadPermissions(permissions);
          console.log(permissions, this.permissionsService);

          this.ngxRolesService.addRoles({
            'RECRUITER': ['CreateInterview'],
            'ADMIN': ['CreateInterview', 'CreateJob', 'DeleteJob'],
            'SUPER_ADMIN': ['CreateTechnology', 'CreateInterview', 'CreateJob', 'DeleteJob'],
            'DEVELOPER': () => { return true; }
          });
        }
        this.router.navigate(['/home']);
        this.invalidLogin = false;
      },
      error => {
        this._toastService.add({
          severity: 'error', summary: '',
          detail: error ? error : Messages.invalidUser
        })
      }
    )
    );
  }

}
